// store/modules/device.js
import { debounce } from 'lodash'
const getDeviceClass = () => {
  let isMobileSize
  const width = window.innerWidth
  switch (true) {
    //当小于1280px但是大于1100px，左侧菜单栏缩放
    case width < 1280 && width > 1100:
      isMobileSize = 'leftHide'
      break

    //当小于1100px但是大于740px，左侧菜单栏缩放 右侧热门用户隐藏
    case width < 1100 && width > 740:
      isMobileSize = 'rightHide'
      break

    //当小于740px，左侧菜单栏应当不能被遮挡缩放
    case width < 740:
      isMobileSize = 'Hide'
      break

    //全尺寸
    default:
      isMobileSize = 'none'
  }
  return isMobileSize
}

export default {
  namespaced: true,
  state: () => ({
    deviceClass: getDeviceClass(), // 直接存储设备类型
  }),
  mutations: {
    // 更新设备类型的 mutation
    UPDATE_DEVICE_CLASS(state) {
      state.deviceClass = getDeviceClass()
    },
  },
  actions: {
    // 初始化监听窗口变化
    initResizeListener({ commit }) {
      const handleResize = debounce(
        () => {
          commit('UPDATE_DEVICE_CLASS')
        },
        0,
        { leading: false, trailing: true }
      ) // 防抖

      window.addEventListener('resize', handleResize)
      window.addEventListener('orientationchange', handleResize) // 处理移动端旋转
    },
  },
  getters: {
    deviceClass: state => state.deviceClass,
  },
}
